import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sevanseatercar() {



  const cardData =
  {
    keyword: '7 Seater Car on Rent in Pune',
    heading: 'Sanavi Travels: 7 Seater Car on Rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable 7 Seater Car on Rent in Pune, providing safe, comfortable, and spacious transportation for families, groups, corporate travelers, and tourists for both local and outstation trips. Our fleet of 7-seater cars is well-maintained with air-conditioning, ample legroom, and generous luggage space, ensuring a smooth and convenient travel experience. With professional chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, reliable, and hassle-free service. We provide convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular destinations such as Lonavala, Mahabaleshwar, Shirdi, Nashik, Mumbai, Goa, Aurangabad, Kolhapur, and Konkan. Choose Sanavi Travels for trusted 7 Seater car rental services in Pune, delivering comfort, safety, and a seamless group travel experience.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha heritage. Once the seat of Peshwa Bajirao I, it features grand gateways like the Delhi Darwaza, massive stone walls, and lush gardens. Though partially destroyed by fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum with Gandhi’s artifacts, photographs, and historical documents, set amidst sprawling gardens and serene ambiance."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, draws thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for extensive charitable work, making it Pune’s spiritual heartbeat."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore ancient ramparts, memorials, and viewpoints. The fort offers breathtaking views of the Sahyadri ranges and local cuisine near the summit."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being in the city center, it maintains tranquility and showcases early Indian craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal depicts historical lifestyles and makes the museum invaluable for art and history enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are mesmerizing."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors seek relaxation, rejuvenation, and personal transformation here."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers provide a serene sanctuary. Families, joggers, and photographers enjoy peaceful walks here."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The reservoir and surrounding hills create picturesque scenery, especially during monsoon. Street vendors add charm, and the dam also serves as the gateway to Sinhagad Fort, making it ideal for weekends and family outings."
  }
]
,




"services": [
  {
    "name": "7 Seater Car on Rent in Pune",
    "description": "Our 7 Seater Car on Rent in Pune provides a versatile and comfortable travel solution for families, groups of friends, or corporate teams needing extra space and convenience. These vehicles are meticulously maintained, air-conditioned, and spacious enough to comfortably accommodate seven passengers along with luggage. Ideal for local city travel, sightseeing tours, weekend getaways, or airport transfers, this service ensures a smooth ride, punctual pickups, and professional chauffeur service. Travelers can enjoy modern interiors, advanced safety features, and a stress-free journey with flexible booking options and transparent pricing, making it a preferred choice for both leisure and business trips."
  },
  {
    "name": "7 Seater Cab Hire Pune",
    "description": "7 Seater Cab Hire in Pune offers a convenient and reliable option for individuals or groups looking for comfortable and hassle-free travel within Pune or to nearby destinations. The vehicles are equipped with spacious seating, ample legroom, and luggage space, making them perfect for family outings, group excursions, or corporate travel. With professional chauffeur-driven service, passengers can relax while the experienced driver navigates traffic efficiently. The service also offers flexible pickup and drop-off points, competitive pricing, and options for short trips, long-distance travel, or day tours, ensuring every journey is safe, comfortable, and enjoyable."
  },
  {
    "name": "AC 7 Seater Cab Pune",
    "description": "AC 7 Seater Cab in Pune ensures a cool and comfortable travel experience regardless of the weather. Perfect for long-distance trips, airport transfers, and city tours, these vehicles provide ample seating and luggage space for up to seven passengers. Each cab is fully air-conditioned and well-maintained, offering modern interiors, safety features, and smooth suspension for a relaxing ride. Professional chauffeurs handle the routes efficiently, ensuring punctual pickups and drop-offs, while passengers can focus on enjoying their journey. This service is ideal for family vacations, group outings, corporate trips, and other travel needs requiring both comfort and reliability."
  },
  {
    "name": "Luxury 7 Seater Car Pune",
    "description": "Luxury 7 Seater Car in Pune provides an elevated travel experience with premium interiors, plush seating, and advanced features designed for maximum comfort. These vehicles are perfect for VIP trips, corporate travel, weddings, or special family outings. Passengers can enjoy smooth rides, climate control, entertainment options, and spacious luggage compartments. Experienced chauffeurs ensure timely arrivals, safe driving, and professional service. With flexible booking, transparent pricing, and personalized attention, luxury 7 seater cabs offer a sophisticated, stress-free, and elegant travel experience, making every journey memorable and enjoyable."
  },
  {
    "name": "Outstation 7 Seater Cab Pune",
    "description": "Outstation 7 Seater Cab from Pune offers convenient and comfortable transport for long-distance journeys to neighboring cities and tourist destinations. Equipped with spacious seating and ample luggage space, these cabs are ideal for family trips, corporate outings, or group travel. Professional chauffeurs follow optimized routes to ensure timely and safe travel, while passengers enjoy a smooth, air-conditioned ride. Flexible packages for one-way or round trips, competitive pricing, and reliable service make this option perfect for travelers seeking comfort, safety, and convenience during outstation journeys."
  },
  {
    "name": "Family 7 Seater Cab Pune",
    "description": "Family 7 Seater Cab in Pune is designed to provide a safe, spacious, and comfortable travel experience for families traveling together. Whether it's a weekend getaway, city sightseeing, airport transfer, or holiday trip, these vehicles accommodate parents, children, and luggage comfortably. The cabs are air-conditioned, well-maintained, and equipped with modern safety features. Chauffeurs are trained to provide courteous, reliable, and punctual service, ensuring a stress-free journey. Flexible booking options and affordable pricing make this service ideal for families looking for convenience, comfort, and a pleasant travel experience."
  },
  {
    "name": "Corporate 7 Seater Cab Pune",
    "description": "Corporate 7 Seater Cab in Pune caters to business travelers, executives, and corporate groups needing reliable and comfortable transport. The vehicles are spacious, air-conditioned, and equipped with amenities suitable for professional travel, including connectivity options and work-friendly interiors. Chauffeurs ensure punctual arrivals and efficient routes, allowing employees to focus on meetings or relax during travel. Ideal for airport transfers, client visits, team outings, and corporate events, this service combines professionalism, comfort, safety, and convenience, making it a preferred choice for corporate transportation needs."
  },
  {
    "name": "Affordable 7 Seater Cab Pune",
    "description": "Affordable 7 Seater Cab in Pune offers budget-friendly transport solutions without compromising on comfort, safety, or reliability. These cabs are spacious, air-conditioned, and suitable for families, groups, and corporate travelers. Professional chauffeurs ensure smooth, timely journeys while passengers enjoy modern interiors, ample luggage space, and a comfortable ride. Flexible packages, competitive pricing, and hassle-free booking make this service ideal for daily travel, weekend trips, sightseeing tours, and outstation travel where comfort and affordability are both important."
  },
  {
    "name": "Chauffeur Driven 7 Seater Cab",
    "description": "Chauffeur Driven 7 Seater Cab in Pune offers a premium, stress-free travel experience for families, groups, and business travelers. Experienced and courteous drivers handle navigation, traffic, and routes, allowing passengers to focus on their journey or work. The vehicles are well-maintained, fully air-conditioned, and spacious, providing comfortable seating and ample luggage space. Ideal for local city travel, airport transfers, corporate trips, family vacations, and long-distance journeys, this service ensures safety, convenience, punctuality, and a professional experience every time."
  },
  {
    "name": "Best 7 Seater Cab Pune",
    "description": "Our Best 7 Seater Cab in Pune offers top-quality vehicles and professional service for the ultimate travel experience. Passengers benefit from spacious, air-conditioned interiors, smooth rides, reliable chauffeurs, and flexible booking options. Suitable for families, friends, and corporate travelers, these cabs provide safe and comfortable transport for city travel, sightseeing, airport transfers, and outstation trips. With a focus on convenience, punctuality, and premium service, this option guarantees a hassle-free and enjoyable travel experience in Pune and surrounding areas."
  },
  {
    "name": "Pune 7 Seater Taxi",
    "description": "Pune 7 Seater Taxi service provides reliable, safe, and comfortable transport for individuals, families, and groups within Pune or to nearby destinations. Vehicles are spacious, air-conditioned, and equipped with ample luggage space. Professional chauffeurs ensure smooth rides, safe driving, and punctual arrivals. Ideal for local city tours, airport transfers, weekend trips, corporate travel, and group outings, this taxi service combines convenience, comfort, and affordability, making it a preferred choice for travelers seeking stress-free transportation with modern amenities and courteous service."
  },
  {
    "name": "Airport 7 Seater Cab Pune",
    "description": "Airport 7 Seater Cab in Pune offers timely and hassle-free pickups and drop-offs for individuals, families, or groups traveling to and from Pune airports. Vehicles are spacious, comfortable, and air-conditioned, capable of accommodating passengers and luggage conveniently. Professional chauffeurs ensure punctual arrivals, safe driving, and efficient routes to avoid delays. This service is ideal for both business and leisure travelers who need reliable, comfortable, and stress-free airport transportation, making travel to or from Pune airports smooth and convenient."
  },
  {
    "name": "Tourist 7 Seater Cab Pune",
    "description": "Tourist 7 Seater Cab in Pune provides a comfortable and reliable way for travelers and groups to explore Pune and nearby tourist destinations. These cabs offer spacious, air-conditioned interiors with ample luggage space and modern amenities. Professional chauffeurs guide passengers safely through city roads, scenic routes, and popular attractions. Suitable for sightseeing, weekend trips, hill station visits, or cultural tours, this service ensures a hassle-free, enjoyable, and memorable travel experience while accommodating the specific needs of tourists and groups."
  },
  {
    "name": "Wedding 7 Seater Cab Pune",
    "description": "Wedding 7 Seater Cab in Pune provides elegant, comfortable, and reliable transport for families and guests attending weddings. These vehicles are spacious, air-conditioned, and perfect for group travel between homes, venues, and hotels. Chauffeurs are experienced, punctual, and trained to provide courteous service, ensuring that all passengers arrive on time and safely. Ideal for transporting family members, friends, or VIP guests, this service offers a hassle-free, luxurious, and convenient travel experience during wedding events."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Online Cab Booking for 7 Seater Cabs in Pune allows travelers to reserve their vehicle quickly and conveniently from any device. Passengers can select preferred cab type, travel date, and pickup location, while enjoying transparent pricing, real-time availability, and instant confirmation. These cabs are spacious, air-conditioned, and chauffeur-driven, providing comfort, safety, and reliability. Perfect for family trips, corporate travel, airport transfers, sightseeing, and long-distance journeys, this service combines modern technology, convenience, and professional transport to ensure a seamless travel experience."
  }
],
"tableData": [
  ["7 Seater Car on Rent in Pune", "7 Seater Cab Hire Pune"],
  ["AC 7 Seater Cab Pune", "Luxury 7 Seater Car Pune"],
  ["Outstation 7 Seater Cab Pune", "Family 7 Seater Cab Pune"],
  ["Corporate 7 Seater Cab Pune", "Affordable 7 Seater Cab Pune"],
  ["Chauffeur Driven 7 Seater Cab", "Best 7 Seater Cab Pune"],
  ["Pune 7 Seater Taxi", "Airport 7 Seater Cab Pune"],
  ["Tourist 7 Seater Cab Pune", "Wedding 7 Seater Cab Pune"],
  ["Online Cab Booking Pune", "—"]
]

,


"whychoose": [
  {
    "WhyChooseheading": "7 Seater Car on Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable 7 seater car rental services in Pune, perfect for family trips, group outings, airport transfers, and outstation travel with comfort and convenience."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Vehicles",
    "WhyChoosedescription": "Travel in air‑conditioned, spacious, and regularly serviced 7 seater cars for a smooth and relaxing journey anywhere in Pune or beyond."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with Pune and surrounding routes, ensuring safe, punctual, and hassle‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for 7 seater car rentals in Pune, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, one‑way, round‑trip, or customized rental plans to suit your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All 7 seater cars are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 7 seater car rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 7 seater cars on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers comfortable and well‑maintained 7 seater cars for rent in Pune.'
  },
  {
    question: 'How can I book a 7 seater car in Pune with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What occasions are suitable for renting a 7 seater car?',
    answer: '7 seater car rentals are ideal for family trips, airport transfers, group outings, and outstation travel.'
  },
  {
    question: 'Are drivers included with the 7 seater car rental?',
    answer: 'Yes, all rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the 7 seater car rental service available 24x7?',
    answer: 'Yes, our 7 seater car rental service in Pune is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all 7 seater cars are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize my 7 seater car rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans based on your travel requirements.'
  },
  {
    question: 'What payment options are available for 7 seater car bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Kulkarni',
    feedback: 'Booked a 7 seater car from Sanavi Travels in Pune. Very spacious and comfortable — perfect for our family trip!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ananya Deshmukh',
    feedback: 'Great experience! The 7 seater car was clean, driver was professional, and the service was excellent throughout.',
    rating: 5
  }
];



















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "7 Seater Car on Rent in Pune - Sanavi Travels",
  "description": "Book 7 Seater cars in Pune with Sanavi Travels. AC and luxury 7 Seater cabs for family trips, corporate travel, airport transfers, weddings, outstation journeys, tourist travel, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>

<Helmet>
  <title>
    7 Seater Car on Rent in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury 7 Seater cars in Pune with Sanavi Travels. Ideal for family trips, corporate travel, airport transfers, weddings, outstation journeys, tourist travel, and chauffeur-driven comfort."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Sevanseatercar;